import { ActiveSelection, Canvas, FabricObject, TPointerEvent, util } from 'fabric';

class CustomFabricCanvas extends Canvas {
  // A draggable multi-selection would take every click inside its bounds; a selection-key
  // click must reach the topmost element there so it can be added to or removed from the selection.
  override findTarget(e: TPointerEvent): FabricObject | undefined {
    const activeObject = this._activeObject;
    if (
      this.skipTargetFind ||
      !(activeObject instanceof ActiveSelection) ||
      !this._isSelectionKeyPressed(e) ||
      activeObject.findControl(this.getViewportPoint(e), util.isTouchEvent(e))
    ) {
      return super.findTarget(e);
    }

    this.targets = [];
    return this.searchPossibleTargets(this._objects, this.getViewportPoint(e));
  }
}

export default CustomFabricCanvas;
